"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollapseState = void 0;
var CollapseState;
(function (CollapseState) {
    CollapseState[CollapseState["Collapse"] = 0] = "Collapse";
    CollapseState[CollapseState["Expand"] = 1] = "Expand";
})(CollapseState || (exports.CollapseState = CollapseState = {}));
